module.exports = __webpack_public_path__ + "media/images/youtube-logo-6acc55790e0c576a695bd83b9b3a62f3.png";